import { FaList } from 'react-icons/fa';

/**
 * Comentários numa célula de tabela — a mesma célula em três lugares.
 *
 * Mora em `molecules/` e não junto de um dos modais que a usam, e isso deixou de ser preferência
 * quando a tela de Faturas passou a mostrá-la: importar de `modals/InvoiceBillingEventsModal`
 * fazia a PÁGINA depender de um módulo de modal, e qualquer teste que dublasse aquele modal
 * derrubava a página inteira com "Element type is invalid".
 *
 * Um comentário só aparece inteiro; vários viram ícone + o ÚLTIMO, com todos no tooltip.
 *
 * Tooltip nativo (`title`) e não o `NewTooltip`: o popup daquele atom é `z-10` e vive DENTRO do
 * corpo `overflow-auto` do modal, então recorta — e todos os modais de billing usam `title`. O
 * `\\n` do title quebra linha nos navegadores.
 *
 * A lista já vem quebrada do backend: o separador dos comentários é regra do domínio, e
 * duplicá-lo aqui faria a tela mostrar um comentário só no dia em que ele mudasse lá.
 */
const CommentCell: React.FC<{ notes: string[] }> = ({ notes }) => {
    if (!notes || notes.length === 0) return <span className="text-gray-400">—</span>;
    if (notes.length === 1) return <span title={notes[0]}>{notes[0]}</span>;
    return (
        <span className="flex items-start gap-1.5" title={notes.join('\n')}>
            <FaList size={11} className="mt-1 shrink-0 text-gray-400" />
            <span className="truncate max-w-[220px]">{notes[notes.length - 1]}</span>
        </span>
    );
};

export default CommentCell;
